import { render } from "./commander.vue?vue&type=template&id=ae1bf0f8"
import script from "./commander.vue?vue&type=script&lang=js"
export * from "./commander.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__